import { Header } from 'antd/es/layout/layout';
import HeaderComponent from './HeaderComponent';
import { useTheme } from '../context/ThemeContext';

interface AppHeaderProps {
  isLoginPage: boolean;
  style?: React.CSSProperties;
  collapsed?: boolean;
  setCollapsed?: (value: boolean) => void;
}

export const AppHeader = ({
  isLoginPage,
  style,
  collapsed,
  setCollapsed,
}: AppHeaderProps): React.ReactElement => {
  const { isDarkMode } = useTheme();
  return (
    <Header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        height: 'auto',
        width: '100%',
        background: isDarkMode ? '#01033c' : '#214175',
        backdropFilter: 'blur(10px)',
        padding: 0,
        WebkitBackdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        lineHeight: 'initial',
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.4)',
        ...style,
      }}
    >
      <HeaderComponent
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        isLoginPage={isLoginPage}
      />
    </Header>
  );
};
